import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=d45ea5b0&"
import script from "./EditContact.vue?vue&type=script&lang=ts&"
export * from "./EditContact.vue?vue&type=script&lang=ts&"
import style0 from "./EditContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports